export const NONE = "None"
export const ASC = "Asc"
export const DESC = "Desc"
export const EMPTY_ARRAY = 0
export const APPLY = "Apply"
export const BUTTON = "button"
export const EXCEPTION_NAME = "exceptionName"
export const SELECT_ALL_EQUIPMENTS = "select-all-equipments"
export const DONE = "Done"
